import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b21af7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "portfolioSection" }
const _hoisted_2 = { class: "portfolioHeader" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headline-medium" }, [
  /*#__PURE__*/_createTextVNode("Descubre el "),
  /*#__PURE__*/_createElementVNode("span", { class: "keyword" }, "impacto"),
  /*#__PURE__*/_createTextVNode(" de nuestras "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("soluciones tecnológicas")
], -1))
const _hoisted_4 = { class: "main-features-list" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<section class=\"portfolioList\" data-v-5b21af7d><article class=\"portfolioItem\" data-v-5b21af7d><iframe class=\"portfolioItem\" width=\"100%\" height=\"100%\" src=\"https://codelabenterprise.com/content/\" data-v-5b21af7d></iframe></article><article class=\"portfolioItem\" data-v-5b21af7d><iframe width=\"100%\" height=\"100%\" src=\"https://codelabenterprise.com/optimize-image/\" data-v-5b21af7d></iframe></article><article class=\"portfolioItem\" data-v-5b21af7d></article><article class=\"portfolioItem\" data-v-5b21af7d></article><article class=\"portfolioItem\" data-v-5b21af7d></article><article class=\"portfolioItem\" data-v-5b21af7d></article><article class=\"portfolioItem\" data-v-5b21af7d></article><article class=\"portfolioItem\" data-v-5b21af7d></article></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeaturesItem = _resolveComponent("FeaturesItem")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_FeaturesItem, {
          text: "Soluciones a tu medida",
          "img-src": "emoji_objects"
        }),
        _createVNode(_component_FeaturesItem, {
          text: "Inovación en cada paso",
          "img-src": "data_exploration"
        }),
        _createVNode(_component_FeaturesItem, {
          text: "Velocidad y  eficiencia juntas",
          "img-src": "speed"
        })
      ])
    ]),
    _hoisted_5
  ]))
}